import { Skeleton } from '@mui/material/';
import { useSelector } from 'react-redux';
import SidebarSkeleton from './templates/SidebarSkeleton';
import SkeletonHeader from './templates/SkeletonHeader';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
const SkeletonLoader = () => {
    var SiteData = useSelector(state => state.SiteData);
    const mdSizeMap = ('bottom-list' === SiteData.sidebarposition || 'bottom-grid' === SiteData.sidebarposition || !SiteData.sidebarposition) ? 12 : 8;
    return(
        <Container maxWidth="xl">
            <Box sx={{ flexGrow: 1 }} className="skHeader">
                <SkeletonHeader />
            </Box>
            <Box sx={{ flexGrow: 1 }} className="skBody">
                <Grid container className="skBodyGrid">
                    {('left' === SiteData.sidebarposition) ? <SidebarSkeleton /> : ''}
                    <Grid item xs={12} md={mdSizeMap}>
                        <Skeleton variant="rectangular" height={640} />
                    </Grid>
                    {('right' === SiteData.sidebarposition) ? <SidebarSkeleton /> : ''}
                </Grid>
                {('bottom-list' === SiteData.sidebarposition || 'bottom-grid' === SiteData.sidebarposition) ? <SidebarSkeleton /> : ''}
            </Box>
      </Container>
    )
}
export default SkeletonLoader